document.addEventListener("DOMContentLoaded", function () {
    topicNav();
    mobilePageTools();
})

function topicNav() {
    const topicNavs = Array.from(document.querySelectorAll(".topics-navigation--main"));
    topicNavs.forEach(nav => highlightActiveTopic(nav));
}

function highlightActiveTopic(nav) {
    const { pathname } = window.location;
    const topicSlug = pathname.split("?")[0].split("/").filter(pathPart => pathPart.length > 0).pop();
    const match = nav.querySelector('[data-slug="' + topicSlug + '"]');

    match
        ? match.classList.add("active")
        : nav.querySelector("li[data-slug=all-topics]").classList.add("active")
}

function mobilePageTools() {
    const bodyTag = document.querySelector("body");
    const pageToolsLaunchBtn = document.getElementById("courses-page-tools-launch-btn");
    const pageToolsCloseBtn = document.getElementById("courses-page-tools-close-btn");
    const pageToolsWrap = document.querySelector(".courses-page-tools");

    pageToolsLaunchBtn.addEventListener("click", function (e) {
        e.preventDefault();
        pageToolsWrap.classList.add("active");
        bodyTag.classList.add("no-scroll");
    });

    pageToolsCloseBtn.addEventListener("click", function (e) {
        e.preventDefault();
        pageToolsWrap.classList.remove("active");
        bodyTag.classList.remove("no-scroll");
    });

    const triggerCloseBtnClick = () => {
        if (window.matchMedia("(min-width: 992px)").matches) {
            pageToolsCloseBtn.click();
        }
    }

    window.addEventListener("resize", triggerCloseBtnClick);
    screen.orientation.addEventListener("change", triggerCloseBtnClick);
}
